import React, {Component}from 'react';
import{Modal, Row, Col,Form} from 'react-bootstrap';  
import '../CSS/addNewExpense.css';
import {connect} from 'react-redux';
import {addExpense} from '../store/actions/expenseActions'
import Dropdown from '../Components/DropDown';
import moment from 'moment';
import firebase from 'firebase';
import {default as UUID} from 'node-uuid';
import Confirm from '../Components/Confirm'
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';


//Displays the AddExpense Modal
  class AddNewExpenseModal extends Component{
  state = {
  trans_id : UUID.v4(),
  user: firebase.auth().currentUser.email,
  description: '',
  amount:'',
  category: '',
  date: ''
  }
  // handle elements in category
  handleDropdown = (category) => {
    this.setState({category});
  };
  handleChange =(e) =>
  {
    this.setState({
      [e.target.id] : e.target.value
    })
  }
  handleSubmit = () => {
    //adds the data to addExpense collection of firebase
    this.props.addExpense(this.state)
   setTimeout(() => {
      alert('Submitted Successfully!')
      }, 1000)
     setTimeout(function(){window.location.reload()}, 3000);
  }

  render(){
  const {category} = this.state;
  console.log(this.state.user);
    if(!this.props.show){
      return null;
  }
    return(
      <div
      size="lg" 
      aria-labelledby="contained-modal-title-vcenter"
      className ="ModalAdd">
      {this.props.children}
    <Modal.Header className ="ModalHeaderAdd">
    </Modal.Header>
    <Modal.Title id="contained-modal-title-vcenter" className = "ModalTitleAdd">
          Submit your expenses
    </Modal.Title>
      <Modal.Body className = "ModalBodyAdd">
      <div className = "container1">
      <Row>
      <Col sm = {10}>
      <Confirm  title = "Are you sure?" className = "confirm">
     {confirm => (
      <Form id = "addExpenses" onSubmit = {confirm(this.handleSubmit)} >
      <Form.Group>
      {/* description is minimun 3 characters and is mandatory field*/}
      <Form.Control
       type ="text"
       name = "ExpenseTitle"
       required
       placeholder = "Expense Description" className = "ExpenseDescriptionInput" id = "description"
       onChange={this.handleChange} minLength = "3"/>
      </Form.Group>
      <Form.Group>
      {/* amount is number and minimun input is $1 characters and is mandatory field*/}
      <Form.Control
       type ="Number"
       name = "ExpenseAmount"
       required
       placeholder = "Expense amount" className = "ExpenseAmountInput"  id = "amount"
       onChange={this.handleChange} min = "1"/>
       {/* category is mandatory field*/}
      </Form.Group>
      <Dropdown 
      data={[
        { value : 'Entertainment', label : 'Entertainment'},
        { value : 'Essentials', label : 'Essentials'},
        { value : 'Apparels', label : 'Apparels'},
        { value : 'Food', label : 'Food'},
        { value : 'Rent', label : 'Rent'},
        { value : 'Miscellaneous', label : 'Miscellaneous'},
      ]}
      value = {category}
      placeholder = 'Select Category'
      onChange={this.handleDropdown}
      />
      {/* date cannot be future and  is mandatory field*/}
      <Form.Group>
      <Form.Control
       type ="date"
       name = "ExpenseDate"
       required
       placeholder = "Enter the Expense Date" className = "ExpenseDateInput" id = "date"  onChange={this.handleChange} max={moment().format("YYYY-MM-DD")}/>
      </Form.Group>

      <button  className = "ButtonSubmitAdd" >Submit</button>
      </Form>
     )}
     </Confirm>
      </Col>
      </Row>
      {/* Hides the Modal on Cancel and reloads the page*/}
      <button className = "ButtonCloseAdd"  onClick={() =>(this.props.onHide).then(window.location.reload())}  >Close</button>
      </div>
      </Modal.Body>
    </div> 
    )
  }
}
//Dispatching the props  with the firebase collection
const mapDispatchToProps = (dispatch) =>{
  return{
   addExpense:(expense) => dispatch(addExpense(expense))

  }
} 
//Connecting the collection and Modal
export default connect(null, mapDispatchToProps)(AddNewExpenseModal)

